import { useMemo } from 'react';
import { usePDPActions, usePDPData, usePDPState } from '~/features/product-details/context';
import { NotifyWhenBack } from '~/features/product-details/components/ProductOverview/components/NotifyWhenBack/NotifyWhenBack';
import { getSalesforceProductImages } from '~/lib/salesforce/utilities/product-images';
import { ReservationDrawer } from '~/features/product-details/components/ReservationDrawer';

/**
 * The overlays live here rather than in ProductOverview so that opening one re-renders this
 * component alone instead of the whole overview subtree.
 */
export const ProductDialogs: React.FC = () => {
    const { product } = usePDPData();
    const { isNotificationDialogOpen, isReservationDrawerOpen } = usePDPState();
    const { setIsNotificationDialogOpen, setIsReservationDrawerOpen } = usePDPActions();

    const featuredImage = useMemo(() => getSalesforceProductImages(product)?.at(0), [product]);

    return (
        <>
            {isReservationDrawerOpen && (
                <ReservationDrawer
                    product={product}
                    showReservationDrawer={isReservationDrawerOpen}
                    featuredImage={featuredImage}
                    setShowReservationDrawer={setIsReservationDrawerOpen}
                />
            )}

            <NotifyWhenBack
                productId={product.id}
                isOpen={isNotificationDialogOpen}
                onOpenChange={setIsNotificationDialogOpen}
            />
        </>
    );
};
